import { readOnly } from 'models/restutil';

export class PenOrderStatusDto {
  public static ApiUrl = 'api/pen-order-statuses';

  Id: number;
  Name: string;
  NameEn: string;
  NameEs: string;
  Created?: Date;
  Updated?: Date;
  @readOnly()
  IsDeleted: boolean;
}
